import { injectable } from '@servicetitan/react-ioc';
import { MarketingApiService } from 'src/api';

@injectable()
export class OptInStore {
    constructor(private marketingApi: MarketingApiService) {}

    optIn() {
        this.marketingApi.optIn();
    }
}
